import React from 'react'
import Page from '../Page'

const HighS = ({ testResult }) => {
    return (
        <>
            <Page
                testResult={testResult}
                title="معرفی الگوی رفتاری"
            >
                <p className="text-gray-800 leading-7">
                    افرادی با الگوی رفتاری High S معمولاً شخصیت‌هایی آرام، باثبات، قابل‌اعتماد و همراه هستند. این افراد آگاهانه سعی می‌کنند تعادل، نظم و هماهنگی را در محیط اطراف خود حفظ کنند و از تنش و بی‌نظمی پرهیز دارند. آن‌ها در کنار دیگران راحت‌اند و معمولاً تلاش می‌کنند که روابطی پایدار، امن و محترمانه با اطرافیان خود ایجاد کنند.
                </p>

                <p className="text-gray-800 leading-7">
                    ارزش‌گذاری آن‌ها بر دیگران بیشتر بر اساس وفاداری، رفتار دوستانه، و قابلیت‌های انسانی است تا جایگاه، قدرت یا سرعت. تأثیرگذاری این افراد به صورت آرام، پیوسته و حمایتی اتفاق می‌افتد، نه با هیاهو یا اعمال قدرت.
                </p>

                <p className="text-gray-800 leading-7">
                    در محیط کاری، معمولاً افرادی هستند که با برنامه‌ریزی دقیق، روش‌های قابل پیش‌بینی و عملکرد منظم، اعتماد دیگران را جلب می‌کنند. آن‌ها ترجیح می‌دهند وظایف خود را در چارچوب‌هایی آشنا و امن انجام دهند و از تغییرات ناگهانی یا تصمیم‌گیری‌های سریع دوری می‌کنند.
                </p>

                <p className="text-gray-800 leading-7">
                    نقاط ضعف محتمل در آن‌ها می‌تواند فروتنی بیش از اندازه، اجتناب از ریسک، و پذیرش بیش از حد نظرات دیگران تحت فشار باشد. همچنین گاهی آن‌قدر به ثبات عادت کرده‌اند که کنار گذاشتن روش‌های قدیمی یا امتحان مسیرهای جدید برایشان سخت است.
                </p>

                <p className="text-gray-800 leading-7">
                    با این حال، این افراد می‌توانند اثربخشی بالاتری داشته باشند اگر یاد بگیرند:
                    نظرات و باورهای خود را با صراحت بیشتری بیان کنند،
                    در مقابل بازخوردها اعتماد به نفس نشان دهند،
                    از روش‌های سریع‌تر و انعطاف‌پذیرتر استفاده کنند،
                    و در موقعیت‌های جدید، با آمادگی قبلی، سرعت تطبیق خود را افزایش دهند.
                </p>

                <p className="text-gray-800 leading-7">
                    روابط آن‌ها معمولاً پایدار و پردوام است، اما دایره روابط اجتماعی‌شان اغلب کوچک و محدود به افراد آشناست. آن‌ها در کنار کسانی که رفتار محترمانه، آرام و باثبات دارند احساس امنیت می‌کنند و با افراد پرهیجان یا پرتنش سازگاری کمتری دارند.
                </p>

                <p className="text-gray-800 leading-7">
                    در کار، بیشتر در حوزه‌های تخصصی و وظایف مشخص می‌درخشند. آن‌ها کارها را بی‌حاشیه، منظم و با دقت پیش می‌برند و در بلندمدت، ثبات عملکرد آن‌ها برای سازمان بسیار ارزشمند است. قدردانی و تأیید دیگران، به حفظ انگیزه و تداوم عملکردشان کمک زیادی می‌کند.
                </p>

                <p className="text-gray-800 leading-7">
                    در مواجهه با تغییرات، به زمان نیاز دارند تا خود را تطبیق دهند. اگر فرصت آمادگی قبلی داشته باشند، بهتر می‌توانند روش‌های خود را بازبینی و اصلاح کنند. در غیر این صورت، ممکن است احساس سردرگمی کنند یا نیاز به حمایت بیشتری داشته باشند.
                </p>

                <p className="text-gray-800 leading-7">
                    در نهایت، افراد High S اگر یاد بگیرند که پرونده‌های قدیمی و بی‌اثر را کنار بگذارند، از فرصت‌های جدید نترسند، و قاطعانه‌تر از خود دفاع کنند، می‌توانند به ترکیبی کم‌نظیر از آرامش، ثبات و اثرگذاری تبدیل شوند.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="ابعاد و توصیف ویژگی‌های رفتاری در الگوی High S"
            >
                <p className="text-gray-800 leading-7">
                    ویژگی شاخص افراد با الگوی High S، ثبات، آرامش و تمایل به حفظ وضعیت موجود است. این افراد در روابط و کارهایشان، به‌دنبال پیش‌بینی‌پذیری، هماهنگی، و دوری از درگیری هستند. آن‌ها اهل ماجراجویی یا ریسک نیستند، اما در محیطی امن، آرام و قابل اتکا، مثل ستون محکمی می‌درخشند.
                </p>

                <p className="text-gray-800 leading-7">
                    افراد High S کارها را پیوسته، با آرامش و قابل‌اعتماد پیش می‌برند. برخلاف تیپ‌هایی که دنبال دیده شدن یا رقابت هستند، این افراد بیشتر به‌دنبال کمک کردن، حمایت از دیگران و ساختن روابطی عمیق و باثبات هستند. اغلب در تیم، شنونده خوبی هستند، اطلاعات را محرمانه نگه می‌دارند و به دوستی و وفاداری اهمیت زیادی می‌دهند.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="نحوه عملکرد در گروه و سازمان"
            >
                <p className="text-gray-800 leading-7">
                    در تیم، افراد High S درگیر رقابت یا نمایش نیستند؛ آن‌ها ترجیح می‌دهند در پشت صحنه با آرامش وظایفشان را انجام دهند. وقتی پروژه‌ای نیاز به پیگیری‌های منظم، کارهای تکراری یا دقت بالا دارد، این افراد انتخاب ایده‌آل هستند.
                </p>

                <p className="text-gray-800 leading-7">
                    اما اگر ناگهان کاری فوری یا چالش‌برانگیز پیش بیاید و از آن‌ها تصمیم سریع خواسته شود، ممکن است دچار فشار یا حتی مقاومت خاموش شوند.
                </p>

                <p className="text-gray-800 leading-7">
                    <strong>مثال کاربردی:</strong>
                    <br />
                    تصور کنید در یک شرکت، پروژه‌ای نیاز به جمع‌آوری اطلاعات مشتریان دارد؛ کاری دقیق، طولانی، یکنواخت و نیازمند توجه بالا. فرد High S با آرامش آن را پیش می‌برد، فایل‌ها را کامل، مرتب و دقیق آماده می‌کند. اما اگر همان فرد یک‌باره مجبور شود در جلسه‌ای تصمیم سریع درباره یک بحران بگیرد، احتمالاً دچار اضطراب یا تأخیر در واکنش خواهد شد.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="ویژگی‌های رفتاری کلیدی"
            >
                <p className="text-gray-800 leading-7">
                    • دوستی‌های عمیق و محدود را ترجیح می‌دهند.
                    <br />
                    • از تنش، درگیری و فضای رقابتی دوری می‌کنند.
                    <br />
                    • در برابر تغییرات سریع، واکنش آرام اما مقاوم دارند.
                    <br />
                    • جامع‌نگر هستند اما گاهی همین جامع‌نگری باعث دشواری در اولویت‌بندی و تصمیم‌گیری می‌شود.
                    <br />
                    • احساسات خود را معمولاً بروز نمی‌دهند و بیشتر در درونشان نگه می‌دارند.
                    <br />
                    • کمتر به نتیجه‌گیری سریع و قاطع گرایش دارند؛ بیشتر مسیر را مهم می‌دانند تا رسیدن فوری به هدف.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="موانع پنهان در رفتار High S"
            >
                <p className="text-gray-800 leading-7">
                    اگرچه این افراد به‌ظاهر آرام و همراه به نظر می‌رسند، اما در درون ممکن است با مقاومت، خستگی عاطفی، یا احساس نادیده گرفته شدن مواجه باشند.
                </p>

                <p className="text-gray-800 leading-7">
                    برای مثال، اگر در محیطی کار کنند که قدردانی دیده نمی‌شود یا رفتار پرخاشگرانه رایج است، آرام‌آرام دلسرد می‌شوند یا از همکاری کنار می‌کشند.
                </p>

                <p className="text-gray-800 leading-7">
                    در تصمیم‌گیری‌های فوری یا پروژه‌هایی که نیاز به ریسک و انعطاف سریع دارد، ممکن است به‌اشتباه به‌عنوان افراد کند یا لجباز برداشت شوند، در حالی که دلیل واقعی، نیاز طبیعی آن‌ها به آرامش، دقت، و پردازش تدریجی تغییرات است.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="پیشنهاد فیلم"
            >
                <p className="text-gray-800 leading-7">
                    فیلم The Intern کارآموز با بازی رابرت دنیرو.
                    <br />
                    در این فیلم، نقش دنیرو نمونه خوبی از شخصیت High S است: فردی آرام، وفادار، شنونده، قابل اعتماد و کاملاً باثبات، که در یک محیط استارتاپی پرسرعت، بدون هیاهو، تبدیل به عامل تعادل تیم می‌شود.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="پیشنهاد سریال"
            >
                <p className="text-gray-800 leading-7">
                    در سریال This Is Us این ما هستیم، شخصیت "رَندال" در فصل‌های اولیه، نمود خوبی از High S است: فردی باوفا، مسئول، آرام و دقیق که در مواجهه با بحران‌ها، اولین واکنشش کمک به خانواده و حفظ آرامش خانه است، نه تصمیم‌گیری آنی یا واکنش احساسی.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="پیشنهاد فیلم"
            >
                <p className="text-gray-800 leading-7">
                    در فیلم The Pursuit of Happyness، شخصیت کریس گاردنر (با بازی ویل اسمیت) در لحظات دشوار زندگی، از فردی با ویژگی‌های پرریسک به فردی باثبات، مسئول، خانواده‌دوست و آرام تبدیل می‌شود.
                    <br />
                    برخی لحظات میانی فیلم می‌توانند بازتابی از ذهنیت و سبک کار High S باشند؛ به‌ویژه جایی که او آرام و بدون درگیری، تلاش می‌کند وضعیت را حفظ کند.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="انگیزه‌ها"
            >
                <p className="text-gray-800 leading-7">
                    افراد با الگوی High S، در جست‌وجوی آرامش، ثبات و روابط پایدار هستند. انگیزه اصلی آن‌ها ایجاد فضایی امن برای خود و اطرافیان است؛ جایی که بتوانند بدون تنش و شتاب‌زدگی، به دیگران کمک کنند و مورد اعتماد باشند.
                </p>

                <p className="text-gray-800 leading-7">
                    شما به‌عنوان فردی با High S، صبر، ملاحظه و جامع‌نگری را در اولویت قرار می‌دهید. در شرایط چالش‌برانگیز به‌جای واکنش‌های سریع یا هیجانی، ترجیح می‌دهید در سکوت تحلیل کنید، روش‌های ساده و قابل اجرا بیابید، و کار را به آرامی اما پیوسته پیش ببرید.
                </p>

                <p className="text-gray-800 leading-7">
                    از تغییر ناگهانی و خطرهای پیش‌بینی‌نشده دوری می‌کنید. روش‌هایی که ثبات، نظم و پیش‌بینی‌پذیری را تضمین می‌کنند، بیش از هر چیزی برای شما انگیزه‌بخش هستند. حفظ وضع موجود، نه از روی انفعال، بلکه از روی احساس مسئولیت و نیاز به امنیت روانی است.
                </p>

                <p className="text-gray-800 leading-7">
                    در جمع دوستان و همکاران، معمولاً به‌عنوان فردی وفادار، شنونده و حامی شناخته می‌شوید. برای شما روابط سطحی جذاب نیستند؛ بلکه دنبال دوستی‌های عمیق، صمیمی و مبتنی بر اعتماد بلندمدت هستید.
                </p>

                <p className="text-gray-800 leading-7">
                    رازگویی دیگران به شما حس ارزشمندی می‌دهد، چون نشان‌دهنده آن است که افراد شما را امن، باثبات و قابل اتکا می‌دانند. همچنین کمک کردن به دیگران برای شما نه‌تنها وظیفه نیست، بلکه منبع رضایت درونی و انگیزه برای ادامه مسیر است.
                </p>

                <p className="text-gray-800 leading-7">
                    <strong>مثال کاربردی:</strong>
                    <br />
                    تصور کنید در محل کارتان، یکی از همکاران دچار فشار روانی است. بدون اینکه درخواست مستقیم کمک کند، شما متوجه می‌شوید و آرام‌آرام، بدون دخالت مستقیم یا جلب توجه، او را حمایت می‌کنید؛ شاید با گوش دادن، یا پوشش دادن بخشی از کار او. این حمایت بی‌صدا برای یک فرد High S، هم طبیعی است و هم انگیزه‌بخش.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="عادت‌های کاری در الگوی رفتاری High S"
            >
                <p className="text-gray-800 leading-7">
                    افراد با الگوی High S معمولاً با سازمان‌دهی، برنامه‌ریزی و آرامش در اجرا شناخته می‌شوند. آن‌ها اهل ریسک نیستند و ترجیح می‌دهند در محیط‌هایی کار کنند که ساختار مشخص، وظایف واضح، و روندهای آشنا وجود داشته باشد. تغییرات ناگهانی یا فشارهای غیرمنتظره می‌تواند آن‌ها را سردرگم یا مضطرب کند.
                </p>

                <p className="text-gray-800 leading-7">
                    شما به‌عنوان یک High S، تلاش می‌کنید کارها را طبق نظم، با دقت و در چارچوب مشخصی انجام دهید. در مسیر رشد شغلی، ترجیح می‌دهید پله‌پله و تدریجی پیش بروید، نه با جهش یا فشار بیرونی. ارتقای شغلی بدون آمادگی قبلی، حتی اگر به نفع‌تان باشد، ممکن است برایتان نگران‌کننده باشد.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="رفتار عمومی در محیط کار"
            >
                <p className="text-gray-800 leading-7">
                    • از سبک‌های کاری پرهیجان یا محیط‌های پرتنش فاصله می‌گیرید.
                    <br />
                    • به‌جای شرکت در بحث‌های پرچالش، بیشتر شنونده و پشتیبان هستید.
                    <br />
                    • اغلب در گروه‌های کوچک، دوستانه و آشنا بهتر عمل می‌کنید تا در تیم‌های گسترده یا رسمی.
                    <br />
                    • با افرادی که اعتماد به نفس بیشتری دارند، احساس امنیت می‌کنید و گاهی ترجیح می‌دهید برخی تصمیمات را به آن‌ها بسپارید.
                    <br />
                    • شما به شیوه‌ها و ابزارهای سنتی و امتحان‌شده اعتماد بیشتری دارید. تا زمانی که یک روش کار می‌کند، ضرورتی برای تغییر آن احساس نمی‌کنید. در نتیجه، ممکن است آخرین نفری باشید که از فرآیندهای جدید استقبال می‌کند.
                </p>

                <p className="text-gray-800 leading-7">
                    <strong>مثال کاربردی:</strong>
                    <br />
                    در یک اداره، سیستم حسابداری قرار است به نسخه جدید نرم‌افزار تغییر پیدا کند. فرد High S در ابتدا نگران است، چون نسخه قبلی را کاملاً بلد بود. او تمایل دارد به استفاده از نسخه قبلی ادامه دهد و منتظر بماند تا دیگران روش جدید را امتحان کنند. اگر آموزش کافی، زمان تطبیق و حمایت تیمی در اختیار او قرار گیرد، در نهایت با دقتی بالا همان سیستم جدید را بهتر از خیلی‌ها اجرا خواهد کرد.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="نقاط قوت و چالش‌ها"
            >
                <div className="w-full overflow-hidden rounded-xl border border-gray-200">
                    <div className="grid grid-cols-2 divide-x divide-gray-200">
                        {/* چالش‌ها */}
                        <div className="bg-white p-4 border-l">
                            <h3 className="text-2xl font-bold text-red-700 mb-6 text-center border-b-2 border-red-300 pb-3">
                                چالش‌ها
                            </h3>
                            <ul className="space-y-4">
                                <li className="flex items-center bg-gray-100 gap-3 p-3 rounded-lg transition-all">
                                    <span className="text-red-500 text-xl mt-1">•</span>
                                    <span className="text-gray-800 leading-relaxed">مقاومت در برابر تغییر</span>
                                </li>
                                <li className="flex items-center bg-gray-100 gap-3 p-3 rounded-lg transition-all">
                                    <span className="text-red-500 text-xl mt-1">•</span>
                                    <span className="text-gray-800 leading-relaxed">وابستگی به افراد مقتدرتر</span>
                                </li>
                                <li className="flex items-center bg-gray-100 gap-3 p-3 rounded-lg transition-all">
                                    <span className="text-red-500 text-xl mt-1">•</span>
                                    <span className="text-gray-800 leading-relaxed">پرهیز از ابتکار در شرایط بحرانی</span>
                                </li>
                                <li className="flex items-center bg-gray-100 gap-3 p-3 rounded-lg transition-all">
                                    <span className="text-red-500 text-xl mt-1">•</span>
                                    <span className="text-gray-800 leading-relaxed">بروز ندادن هیجانات یا احساسات</span>
                                </li>
                            </ul>
                        </div>

                        {/* نقاط قوت */}
                        <div className="bg-white p-4">
                            <h3 className="text-2xl font-bold text-green-700 mb-6 text-center border-b-2 border-green-300 pb-3">
                                نقاط قوت
                            </h3>
                            <ul className="space-y-4">
                                <li className="flex items-center bg-gray-100 gap-3 p-3 rounded-lg transition-all">
                                    <span className="text-green-500 text-xl mt-1">✓</span>
                                    <span className="text-gray-800 leading-relaxed">پیگیری دقیق کارهای تکراری و ثابت</span>
                                </li>
                                <li className="flex items-center bg-gray-100 gap-3 p-3 rounded-lg transition-all">
                                    <span className="text-green-500 text-xl mt-1">✓</span>
                                    <span className="text-gray-800 leading-relaxed">توان هماهنگ‌سازی تیم‌های کوچک</span>
                                </li>
                                <li className="flex items-center bg-gray-100 gap-3 p-3 rounded-lg transition-all">
                                    <span className="text-green-500 text-xl mt-1">✓</span>
                                    <span className="text-gray-800 leading-relaxed">صبوری و نظم در اجرا</span>
                                </li>
                                <li className="flex items-center bg-gray-100 gap-3 p-3 rounded-lg transition-all">
                                    <span className="text-green-500 text-xl mt-1">✓</span>
                                    <span className="text-gray-800 leading-relaxed">توان تحمل فشارهای عاطفی</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </Page>


            <Page
                testResult={testResult}
                title="دیدگاه‌ها و نگرش‌های افراد با الگوی High S"
            >
                <p className="text-gray-800 leading-7">
                    افراد با الگوی  High S تمایل دارند که در نگاه دیگران فردی وفادار، قابل اتکا، صمیمی و فروتن باشند. آن‌ها آرامش و هماهنگی را در روابط انسانی ارزشمند می‌دانند و سعی می‌کنند همیشه پشتوانه‌ای آرام و مطمئن برای اطرافیان باشند.
                    شما به عنوان یک  High S، اگر حس کنید دیگران به شما اعتماد دارند و از شما قدردانی می‌کنند، انگیزه‌تان برای ادامه دادن، حمایت کردن و اجرای دقیق کارها چند برابر می‌شود. بازخوردهای مثبت، به‌خصوص اگر با احترام و دوستی همراه باشد، به شما کمک می‌کند تا عملکرد خود را حفظ یا حتی ارتقاء دهید.
                </p>

                <p className="text-gray-800 leading-7">
                    در مقابل، اگر تغییری ناگهانی یا فضایی پرتنش ایجاد شود، آرامش درونی شما ممکن است دچار اختلال شود. در این مواقع، مهم است که خود را بهتر بشناسید و برای سازگاری با شرایط جدید، راهکارهای شخصی و تدریجی داشته باشید. دنبال حذف کامل تنش‌ها نباشید، بلکه یاد بگیرید چگونه در کنار آن‌ها آرام بمانید.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="در رابطه با دیگران و مسئولیت‌ها"
            >
                <p className="text-gray-800 leading-7">
                    شما معمولاً تمایل دارید کنترل وظایف را نزد خود نگه دارید. تفویض اختیار ممکن است برایتان سخت باشد، چون احساس می‌کنید کارها باید با دقت و روش خودتان انجام شود.
                    اما اگر یاد بگیرید در موقعیت‌های تیمی بخشی از کار را با اعتماد به دیگران واگذار کنید، هم سرعت کار بالا می‌رود، هم حس مشارکت در تیم افزایش می‌یابد.
                </p>

                <p className="text-gray-800 leading-7">
                    در برخی موقعیت‌های چالشی، ممکن است بدون آنکه متوجه شوید، تسلیم خواسته دیگران شوید یا لجبازی پنهان بروز دهید. این اتفاق معمولاً نه از روی ضعف، بلکه از میل به حفظ آرامش و دوری از درگیری است. برای اینکه تأثیرگذارتر باشید، بهتر است رویکرد حل مسئله و ارائه نظر قاطعانه اما محترمانه را تمرین کنید.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="قدرت واقعی شما کجاست"
            >
                <p className="text-gray-800 leading-7">
                    قدرت شما در این است که می‌توانید فرآیندها را منظم، تیم را یکپارچه، و روابط را باثبات نگه دارید. وقتی در تیمی نقش پشتیبانی و هماهنگی را به‌درستی ایفا کنید، هم اعضا احساس امنیت می‌کنند، هم مسیر رسیدن به نتیجه هموارتر می‌شود.
                    در واقع، شما با مهارت در ایجاد فضاهای امن و صمیمی، وفاداری و تعلق خاطر دیگران به گروه را تقویت می‌کنید.
                </p>

                <p className="text-gray-800 leading-7">
                    <strong>مثال کاربردی:</strong>
                    <br />
                    فرض کنید تیمی در آستانه برگزاری یک رویداد مهم قرار دارد و اعضا نگران جزئیات اجرایی هستند. فرد  High S با بررسی بی‌سروصدا، یادآوری کارهای انجام‌نشده، هماهنگ‌سازی افراد و اطمینان‌بخشی به اعضای تیم، کاری می‌کند که همه حس کنند "کسی هست که حواسش به همه چیز هست." این یعنی اثرگذاری آرام ولی قدرتمند.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="اوقات فراغت در الگوی رفتاری High S"
            >
                <p className="text-gray-800 leading-7">
                    افراد با الگوی  High S در اوقات فراغت به دنبال آرامش، امنیت عاطفی و فضاهای آشنا و صمیمی هستند. آن‌ها ترجیح می‌دهند لحظات آزاد خود را در کنار خانواده یا دوستان نزدیک سپری کنند؛ نه در جمع‌های شلوغ و پرهیاهو.
                    برای شما به‌عنوان فرد  High S، بودن در طبیعت مثل در آغوش گرفتن یک منبع انرژی خاموش است. قدم زدن در فضای سبز، گوش دادن به صدای پرندگان، باغبانی، زنبورداری، یا حتی رسیدگی به گیاهان خانگی، می‌تواند یک منبع آرامش درونی و بازیابی ذهنی باشد.
                </p>

                <p className="text-gray-800 leading-7">
                    شما معمولاً به جای تفریحات پرهیجان یا پرریسک، به دنبال فعالیت‌هایی هستید که عمق، معنا و حس پیوند در آن‌ها وجود داشته باشد. حتی اگر به مسافرت بروید، ترجیح می‌دهید اقامت‌گاهی دنج، با فضای منظم و قابل پیش‌بینی انتخاب کنید تا جایی پر سر و صدا و پر اتفاق.
                    اوقات فراغت برای شما، فرصتی است برای بازسازی انرژی روانی، تقویت روابط نزدیک، و اتصال دوباره به دنیای درونی خود. آرامش طبیعت، صمیمیت خانواده، و حس مفید بودن در کنار این دو، فرمولی است که بارها برایتان کار کرده و به آن وفادار مانده‌اید.
                </p>

                <p className="text-gray-800 leading-7">
                    <strong>مثال کاربردی:</strong>
                    <br />
                    اگر به شما پیشنهاد شود در یک روز تعطیل بین رفتن به شهربازی شلوغ یا یک پیک‌نیک خانوادگی در باغ، یکی را انتخاب کنید، با احتمال زیاد گزینه دوم را انتخاب می‌کنید؛ آنجا می‌توانید بدون فشار، در کنار آدم‌های مورد اعتمادتان نفس بکشید و خودِ واقعی‌تان باشید.
                    در انیمیشن تحسین‌شده My Neighbor Totoro همسایه‌ام توتورو،
                    فضای آرام، طبیعت، خانواده و ارتباط بی‌کلام میان انسان و محیط،
                    کاملاً با روحیه  High S هم‌خوان است.
                </p>
            </Page>


            <Page
                testResult={testResult}
                title="پیشنهادات برای بهبود عملکرد High S"
            >

                <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>تصمیم‌گیری در الگوی رفتاری High S</h3>

                <p className="text-gray-800 leading-7">
                    یکی از چالش‌های رایج در افراد با الگوی  High S، تعلل در تصمیم‌گیری است. این موضوع معمولاً نه به‌دلیل ضعف، بلکه ناشی از ویژگی‌هایی مثل جامع‌نگری، تمایل به در نظر گرفتن همه جوانب، و پرهیز از ایجاد تنش یا اشتباه است.
                    شما اغلب سعی می‌کنید تمامی ابعاد یک مسئله را ببینید، همه را راضی نگه دارید، به احساسات کسی آسیب نزنید، و تصمیمی بگیرید که کاملاً بدون ریسک باشد. اما نتیجه این سبک، معمولاً تأخیر در تصمیم‌گیری یا جا ماندن از فرصت‌هاست.
                </p>

                <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>برای بهبود این روند، پیشنهاد می‌شود:</h3>

                <p className="text-gray-800 leading-7">
                    1. ساده‌سازی و اولویت‌بندی را تمرین کنید.
                    هر تصمیم قرار نیست کامل یا بی‌نقص باشد. از خود بپرسید:
                    «الان مهم‌ترین عامل موفقیت در این تصمیم چیست؟»
                    «چه چیزی بیشترین تأثیر را دارد؟»
                    <br />
                    <br />
                    2. به جای تمرکز روی همه، تصمیم را بر اساس واقعیت‌های موجود بگیرید.
                    قرار نیست همه راضی باشند؛ قرار است تصمیم در مسیر حل مسئله باشد.

                    <br />
                    <br />
                    3. با افرادی که در تصمیم‌گیری سریع و تحلیلی قوی‌اند، مشورت کنید. تیپ‌های شخصیتی مثل High C ، CS، DI  و DC  می‌توانند به شما در تحلیل منطقی، بررسی ریسک‌ها، یا حتی خارج شدن از حالت تعلل کمک کنند.

                    <br />
                    <br />
                    4. در تصمیم‌گیری‌های حساس، احساسات را به‌عنوان یکی از داده‌ها ببینید، نه تنها معیار.
                    مهم است که به دل خود گوش بدهید، اما کافی نیست. اطلاعات، منطق و تجربه باید وزنه اصلی باشند.
                    <br />
                    <br />
                    5. تمرین تصمیم‌گیری در موضوعات ساده را به صورت روزمره انجام دهید.
                    برای مثال: «امروز در انتخاب مسیر رفتن به محل کار، سریع‌تر تصمیم بگیرم.»
                    «در خریدهای جزئی، معیار اصلی را مشخص کنم و وقت زیادی نگذارم.»
                </p>

            </Page>

            <Page
                testResult={testResult}
                title="مثال کاربردی"
            >
                <p className="text-gray-800 leading-7">
                    فرض کنید باید بین دو فرصت شغلی یکی را انتخاب کنید. فرد  High S ممکن است بخواهد همه ابعاد شخصی، خانوادگی، شغلی، مالی، اخلاقی، اجتماعی و حتی احساسات دیگران را هم‌زمان بررسی کند. این وسواس، باعث تأخیر زیاد و استرس می‌شود. اگر در این شرایط، شخصی با تیپ High C  تحلیلی یا DI  اقدام‌گرا در کنار او باشد، می‌تواند کمک کند گزینه‌ها روشن‌تر دیده شوند و تصمیم ساده‌تر و سریع‌تر گرفته شود.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="پیشنهادات عملی برای بهبود عملکرد افراد با الگوی High S"
            >
                <p className="text-gray-800 leading-7">
                    افراد  High S معمولاً در فضاهای باثبات و قابل پیش‌بینی درخشان‌اند. اما برای رسیدن به رشد شخصی و حرفه‌ای، لازم است با برخی از الگوهای رفتاری طبیعی خود آگاهانه مقابله کنند و توانایی‌های مکمل را در خود پرورش دهند.
                </p>

                <p className="text-gray-800 leading-7">
                    1. قدرت تصمیم‌گیری و اقدام را در خود تقویت کنید:
                    خودتان را در معرض موقعیت‌هایی قرار دهید که نیاز به تصمیم‌گیری سریع دارند.
                    با مسائلی که نیاز به انتخاب فوری دارند (حتی در زندگی روزمره) تمرین کنید تا از تعلل خارج شوید.
                    در کنار دوستان یا همکارانی با تیپ‌های High D ، High C ، DI  یا DC  قرار بگیرید تا از سبک تحلیل، اقدام‌محور بودن، قاطعیت و سرعت آن‌ها الهام بگیرید.

                    <br />
                    <br />
                    2. از چالش نترسید؛ به استقبال آن بروید: در بحث‌های استدلالی و فکری شرکت کنید، حتی اگر مخالف نظر جمع باشید. در پروژه‌های جدید، ایده‌پردازی کنید و در اجرای آن‌ها نقش بگیرید، حتی اگر احساس آمادگی صددرصد ندارید. شرکت در ورزش‌های رقابتی یا فعالیت‌های گروهی چالشی مثل کوهنوردی یا شطرنج تیمی، ذهن تصمیم‌گیر و جسور شما را بیدار می‌کند.

                    <br />
                    <br />
                    3. استقلال و تمرکز فردی را تقویت کنید: برای برخی تصمیمات، خودتان پیش‌قدم شوید، بدون مشورت یا تأیید خانواده یا اطرافیان. وابستگی عاطفی را آگاهانه مدیریت کنید؛ گاهی "نه گفتن" به دیگران، بله گفتن به خودتان است. نیازهای شخصی‌تان را بشناسید، به آن‌ها احترام بگذارید و بدون احساس گناه بیانشان کنید.

                    <br />
                    <br />
                    4. نتیجه‌گرایی و پیگیری هدف را وارد فرهنگ کاری‌تان کنید:
                    به‌جای اینکه فقط وظیفه را انجام دهید، روی خروجی و کیفیت نتیجه تمرکز کنید.
                    برای رسیدن به اهداف زمانی مشخص تعیین کنید، پیگیری داشته باشید و تا رسیدن به نتیجه عقب نکشید.
                    یاد بگیرید چگونه از فرصت‌های پیش‌آمده سریع استفاده کنید؛ فرصت‌طلبی مثبت یعنی دیدن زودتر، عمل کردن سریع‌تر.
                    <br />
                    <br />
                    5. اولویت‌بندی را جایگزین جامع‌نگری افراطی کنید:
                    شما به‌طور طبیعی جامع‌نگر هستید، اما دیدن همه چیز هم‌زمان ممکن است شما را از تشخیص اولویت‌ها دور کند.
                    سعی کنید در هر موقعیت، دو یا سه عامل مهم را جدا کنید و فقط بر آن‌ها تمرکز کنید.
                    تصمیم‌گیری خوب، همیشه از دیدن کامل شروع نمی‌شود، گاهی از تمرکز عمیق روی یک نقطه مهم شروع می‌شود.
                </p>
            </Page>

            <Page
                testResult={testResult}
            >
                <p className="text-gray-800 leading-7">
                    6. حمایت از دیگران را آگاهانه مدیریت کنید:
                    قبل از اینکه به کسی کمک کنید، از او بپرسید که آیا واقعاً نیاز دارد یا نه.
                    برای حمایت از دیگران، محدوده مشخص و قابل مدیریت تعریف کنید تا خسته یا بی‌انرژی نشوید.
                    اگر مدام در نقش حامی باشید اما برای خود زمان و انرژی نگذارید، دچار فرسودگی خواهید شد.
                </p>

                <p className="text-gray-800 leading-7">
                    <strong>مثال کاربردی:</strong>
                    <br />
                    فرض کنید در یک تیم کاری هستید که به سرعت باید برای یک پروژه تصمیم بگیرد. شما با طبیعت محتاط و جامع‌نگر خود تمایل دارید همه چیز را کامل ببینید، اما وقت نیست. در اینجا، به‌جای تحلیل همه جوانب، روی دو گزینه اصلی تمرکز کرده، مزایا و معایبشان را به‌سرعت لیست می‌کنید و در مشورت با یک همکار High C  یا DI  تصمیم‌تان را نهایی می‌کنید.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="رمز موفقیت افراد با الگوی High S"
            >
                <p className="text-gray-800 leading-7">
                    اگرچه افراد  High S در ثبات، وفاداری و حمایتگری بی‌نظیرند، اما برای دستیابی به موفقیت‌های چشم‌گیرتر، لازم است برخی توانمندی‌های مکمل را در خود تقویت کنند. رمز موفقیت آن‌ها در توازن میان آرامش درونی و جسارت بیرونی نهفته است.
                </p>


                <p className="text-gray-800 leading-7">
                    1. اقدام کردن، حتی وقتی شرایط کامل نیست
                    گاهی آن‌قدر منتظر موقعیت ایده‌آل می‌مانید که زمان طلایی از دست می‌رود. اقدام کردن، حتی با اطلاعات ناقص، تمرینی است برای خروج از منطقه امن و تجربه رشد.

                    <br />
                    <br />
                    2. جسارت در تصمیم‌گیری و ابراز وجود
                    موفقیت برای  High S در گرو تمرین جسارت است—جسارت در "نه" گفتن، در بیان خواسته‌ها، در گرفتن تصمیم‌هایی که همیشه عقب انداخته شده‌اند.

                    <br />
                    <br />
                    3. پذیرش تغییر و تحول
                    تغییر را دشمن آرامش نبینید؛ بلکه فرصتی بدانید برای شکوفایی نسخه جدیدی از خودتان. برنامه‌ریزی برای تغییر، آن را برای شما قابل مدیریت می‌کند.

                    <br />
                    <br />
                    4. تقویت مهارت حل مسئله
                    به‌جای عقب‌نشینی از مسئله یا صبر کردن برای حل شدن خودکار، با ذهن باز و تحلیل منطقی وارد شوید. حل مسئله ترکیبی از شجاعت، خلاقیت و تصمیم‌گیری است.

                    <br />
                    <br />
                    6. مدیریت مؤثر زمان
                    زمان برای افراد  High S گاهی در برنامه‌ریزی‌های زیاد و وسواس‌های رفتاری گم می‌شود. موفقیت یعنی یاد بگیرید کدام کارها باید الان انجام شود و کدام‌ها نه.
                    <br />
                    <br />

                    7. بیان احساسات به‌جای پنهان کردن
                    اگرچه پنهان‌کاری احساسی ممکن است برای حفظ آرامش مفید باشد، اما در بلندمدت، باعث سوءتفاهم و فشار روانی می‌شود. یاد بگیرید احساسات را محترمانه و شفاف بروز دهید.

                    <br />
                    <br />
                    8. قضاوت نکردن، اما تحلیل کردن
                    پرهیز از قضاوت‌های سطحی یکی از نقاط قوت شماست. اما این نقطه قوت وقتی با تحلیل دقیق و واقع‌گرایانه همراه شود، به تصمیم‌سازی مؤثر منجر خواهد شد.
                </p>
            </Page>


            <Page
                testResult={testResult}
            >
                <p className="text-gray-800 leading-7">
                    9. تمرکز بر نتیجه، نه فقط انجام وظیفه
                    فقط کار کردن کافی نیست؛ باید برای نتیجه کار برنامه داشته باشید، پیگیری کنید و خروجی ملموس بسازید. نتیجه‌گرایی یعنی هوشمندانه کار کردن، نه صرفاً سخت کار کردن.

                    <br />
                    <br />
                    10. تقویت مهارت «نه گفتن»
                    مرز گذاشتن یعنی حفظ انرژی روانی و تمرکز. اگر همیشه بله بگویید، در نهایت نه به خودتان می‌گویید. تمرین نه گفتن محترمانه، مسیر موفقیت شما را هموارتر می‌کند.

                    <br />
                    <br />
                    11. افزایش سرعت در اقدام و تصمیم
                    گاهی لازم است بدون بررسی کامل، بر اساس تجربه و شهود تصمیم بگیرید. تمرین کنید گاهی سریع‌تر بجنبید، حتی اگر کاملاً آماده نیستید—چون زندگی همیشه منتظر آمادگی شما نمی‌ماند.

                    <br />
                    <br />
                    <strong>مثال کاربردی:</strong>
                    <br />
                    «فردی با تیپ  High S، برای تغییر شغل ماه‌ها تعلل کرده چون نمی‌خواست مدیر فعلی‌اش ناراحت شود. وقتی تصمیم گرفت فقط یک قدم جلو برود، یعنی رزومه‌اش را ارسال کند، متوجه شد که مسیر جدید نه‌تنها بهتر است، بلکه حتی باعث احترام و حمایت مدیر قبلی‌اش شد.»

                </p>
            </Page>

            <Page
                testResult={testResult}
                title="چگونه افراد High S لایه‌های D ، C و I را در خود تقویت کنند؟"
            >
                <p className="text-gray-800 leading-7">
                    برای رشد فردی و حرفه‌ای، افراد  High S نیاز دارند بخشی از ویژگی‌های الگوهای دیگر را در خود تعدیل یا تقویت کنند. سه لایه مهم که تقویت آن‌ها برای  High S بسیار مؤثر است:
                </p>

                <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>
                    تقویت لایه D  تسلط و قاطعیت:
                </h3>

                <p className="text-gray-800 leading-7">
                    برای رهایی از تعلل و وابستگی زیاد به محیط، باید یاد بگیرید گاهی قاطعانه، سریع و مستقل تصمیم بگیرید.
                    از کلمه "قاطعیت" در تصمیم‌گیری‌های روزمره استفاده کنید.
                    جمله‌ای را در ذهن خود تکرار کنید:
                    «در مواقع لزوم باید قاطعانه نه بگویم.»
                    ریسک کردن رمز موفقیته. گاهی باید به دل چالش بزنید، حتی اگر همه چیز آماده نباشد.
                    در جلسات، نقش پیشنهاددهنده فعال را بگیرید، نه فقط شنونده.

                </p>

                <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>
                    تقویت لایه C  تحلیل و منطق:
                </h3>

                <p className="text-gray-800 leading-7">
                    گرایش ذاتی شما به احساس و ارتباطات گاهی ممکن است تصمیم‌گیری منطقی را به تأخیر بیندازد. برای تعادل:
                    از کلمه‌هایی مثل "تحقیق"، "منطقی"، "تحلیل" و "اولویت‌بندی" در برنامه‌ریزی‌هایتان استفاده کنید.
                    تمرین کنید هر تصمیم را با یک چک‌لیست منطقی و بدون قضاوت عاطفی بررسی کنید.
                    "مدیریت زمان" و "برنامه‌ریزی دقیق" را به‌عنوان ابزار رشد شخصی بشناسید.
                    مثال: قبل از انجام یک کار، یک جدول بسازید:
                    چه کاری، چرا، کی، با چه منابعی، و چه پیامدی؟ این تمرین ذهن شما را به سمت ساختاردهی و تصمیم دقیق سوق می‌دهد.
                </p>

                <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>
                    تقویت لایه I انرژی، بیانگری و هیجان مثبت:
                </h3>

                <p className="text-gray-800 leading-7">
                    برای تأثیرگذاری بیشتر و تقویت حضور اجتماعی، نیاز است با احساسات مثبت بیشتر ارتباط بگیرید.
                    کلماتی مثل "بیانگر بودن"، "مشتاق بودن"، و "بروز هیجانات مثبت" را در برنامه‌های روزانه خود جای دهید.
                    برای ایجاد جذابیت بیشتر در ارتباطات، گاهی شاد و پرانرژی صحبت کنید، حتی اگر احساس خستگی دارید.
                    در جمع‌ها شروع‌کننده گفتگو باشید.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="جملات کلیدی برای تمرین ذهنی روزانه"
            >
                <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
                    <li>ریسک کردن رمز موفقیته.</li>
                    <li>رفع نیازهای خودم مقدم بر نیازهای دیگرانه.</li>
                    <li>توانمند کردن دیگران بهتر از حمایت صرفه.</li>
                    <li>ماهی‌گیری بهتر از ماهی دادنه.</li>
                    <li>فرصت‌طلبی مثبت، شاه‌کلید موفقیته.</li>
                    <li>باید به‌موقع و قاطعانه نه بگم.</li>
                    <li>استقلال در انجام کارها لازمه رشده.</li>
                    <li>ما باید به سمت چالش‌ها و تغییرات جدید حرکت کنیم.</li>
                    <li>قبل از کمک به دیگران، ازشون بپرس که واقعاً کمک می‌خوان یا نه.</li>
                </ul>
            </Page>

            <Page
                testResult={testResult}
                title="دانش و مهارت‌های آموزشی مورد نیاز برای بهبود عملکرد افراد High S"
            >
                <p className="text-gray-800 leading-7">
                    برای رشد فردی و حرفه‌ای، افراد با تیپ  High S نیاز دارند علاوه بر تکیه بر ویژگی‌های طبیعی خود مثل آرامش، وفاداری و حمایت‌گری، مجموعه‌ای از مهارت‌های مکمل را نیز به‌صورت آگاهانه یاد بگیرند و تمرین کنند.
                </p>

                <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>
                    1. مهارت‌های مدیریت فردی و زمان:
                </h3>

                <p className="text-gray-800 leading-7">
                    مدیریت زمان و برنامه‌ریزی مؤثر، هدف‌گذاری و برنامه‌ریزی آینده‌نگر، مدیریت هزینه‌ها و منابع شخصی، مدیریت تغییرات و سازگاری تدریجی با آن‌ها، هنر نظم‌پذیری و پایبندی به برنامه‌ها
                </p>

                <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>
                    2. مهارت‌های ذهنی و تصمیم‌سازی:
                </h3>

                <p className="text-gray-800 leading-7">
                    تفکر انتقادی و تحلیل منطقی موضوعات، بررسی فرضیه‌ها و احتمالات قبل از اقدام، تصمیم‌گیری سریع و شکار فرصت‌ها، هنر اولویت‌بندی و تشخیص کار مهم از غیرضروری
                </p>

                <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>
                    3. مهارت‌های احساسی و روان‌شناختی:
                </h3>

                <p className="text-gray-800 leading-7">
                    کنترل هیجانات منفی و تقویت هیجانات مثبت، هوش هیجانی برای درک و مدیریت احساسات خود و دیگران، هنر بیان احساسات به‌موقع و صادقانه، افزایش اعتماد به نفس و جسارت در ابراز وجود، هنر پذیرش انتقاد بدون فروپاشی روانی
                </p>

                <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>
                    4. مهارت‌های بین‌فردی و ارتباطی:
                </h3>

                <p className="text-gray-800 leading-7">
                    ارتباط مؤثر و فعال در جمع‌های کاری یا دوستانه، هنر نه گفتن با احترام و قاطعیت ورزی آگاهانه، پیشگام بودن در تعاملات، نه صرفاً همراه بودن، فرصت‌طلبی مثبت در جمع‌ها، پروژه‌ها و مذاکره‌ها
                </p>

                <h3 className='text-xl text-gray-800 mt-2 -mb-1.5 font-bold text-center'>
                    5. مهارت‌های تخصصی و آینده‌نگر:
                </h3>

                <p className="text-gray-800 leading-7">
                    مدیریت استراتژیک در محیط‌های کاری و تصمیم‌های فردی، حل مسئله با رویکرد ساختارمند و نه احساسی، خلاقیت و نوآوری برای عبور از مسیرهای تکراری، هوش مالی برای استقلال فردی و تصمیم‌گیری اقتصادی آگاهانه
                </p>

            </Page>

            <Page
                testResult={testResult}
                title="نکته کلیدی"
            >
                <p className="text-gray-800 leading-7">
                    <ul className="text-gray-800 leading-7 list-disc list-inside space-y-2">
                        <li>آگاهی از خلأها (تشخیص نیاز)</li>
                        <li>یادگیری مهارت (با تمرین‌های مشخص)</li>
                        <li>به‌کارگیری در موقعیت‌های واقعی</li>
                    </ul>
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="مشاغل مناسب برای افراد با الگوی رفتاری High S"
            >
                <p className="text-gray-800 leading-7">
                    افراد دارای الگوی  High S معمولاً در مشاغلی موفق‌اند که نیازمند ثبات، دقت، حمایت از دیگران، همکاری در محیط‌های امن، و رویکرد خدمات‌محور است. این افراد ترجیح می‌دهند در محیط‌هایی کار کنند که فضای آن قابل پیش‌بینی، بدون تنش، منظم و همراه با روابط انسانی مثبت باشد.
                    با این حال، انتخاب شغل تنها بر اساس الگوی رفتاری کافی نیست. تست رغبت شغلی (6 بُعد اصلی شامل: واقع‌گرا، جستجوگر، اجتماعی، قراردادی، تهوری و هنری) می‌تواند مکمل بسیار مهمی برای تشخیص مسیر شغلی مناسب باشد.
                    <br />
                    <strong>توصیه مهم:</strong>
                    <br />
                    حتماً با مشاور آگاه به رفتارشناسی، منابع انسانی و آینده بازار کار مشورت کنید تا علاقه، استعداد و کشش بازار را با هم ترکیب کنید.
                </p>

                <p className="text-gray-800 leading-7">
                    <strong>1. معلم کودکان خاص:</strong> نیاز به صبر، همراهی، همدلی و تکرار زیاد دارد. محیط نسبتاً پایدار است و نیازمند ارتباط عاطفی عمیق با کودکان.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>2. مددکار اجتماعی:</strong> فضای حمایتی، مراقبتی و مبتنی بر رابطه انسانی دارد. افراد High S، منبع آرامش و اعتماد برای دیگران هستند.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>3. کارشناس بیمه:</strong> کاری دقیق، با فرآیندهای مشخص و روال‌های قابل پیش‌بینی. نیاز به دقت بالا، پیگیری مستمر و خدمات‌رسانی دارد.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>4. کارمند اداری:</strong> محیط منظم، چارچوب‌دار و قابل پیش‌بینی. افراد High S در نظم‌دهی به فرآیندها و هماهنگی با همکاران بسیار موفق عمل می‌کنند.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>5. کشاورز یا باغبان:</strong> ارتباط مستقیم با طبیعت، آرامش، تکرار فرآیندها، صبر و برنامه‌ریزی بلندمدت، همه ویژگی‌های مطلوب برای High S
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>6. مراقب پرواز:</strong> تمرکز بالا، آرامش ذهنی، و نیاز به اجرای دقیق دستورالعمل‌ها. فضای بدون حاشیه و با مسئولیت مشخص.
                </p>
            </Page>

            <Page
                testResult={testResult}
            >
                <p className="text-gray-800 leading-7">
                    <strong>7. جنگلبان:</strong> ترکیبی از عشق به طبیعت، تعهد به نگهداری، و عملکرد در محیط نسبتاً پایدار و قابل اعتماد.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>8. زمین‌شناس:</strong> نیازمند صبر، تحلیل‌گری، مشاهده دقیق و برنامه‌ریزی گام‌به‌گام—همه ویژگی‌های مطلوب High S.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>9. تعمیرکار لوازم خانگی:</strong> کار دقیق، با فرآیند مشخص و محیط کم‌تنش. افراد High S معمولاً به جزئیات توجه خوبی دارند و اعتماد مشتری را جلب می‌کنند.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>10. حسابدار:</strong> الگوی تکراری، قوانین مشخص، دقت بالا و حداقل نیاز به ریسک. فضای کاری برای High S بسیار مناسب است.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>11. آشپز:</strong> ترکیبی از نظم، دقت، و تکرار در چارچوب. اگر محیط بدون تنش باشد، افراد High S خلاقیت خوبی هم از خود نشان می‌دهند.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>12. مکانیک:</strong> نیاز به ثبات، دقت، و بررسی تدریجی خطاها. بسیاری از High Sها در این کار احساس امنیت و تسلط دارند.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>13. راننده سرویس مدارس:</strong> ثبات مسیر، تعامل با کودکان، مسئولیت‌پذیری، و اعتمادسازی، همه در محدوده آرامش رفتاری High S است.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>14. خیاط:</strong> دقت، کار با دست، محیط آرام، فرآیندهای تکرارشونده، و خروجی ملموس، بسیار سازگار با روحیه High S.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>15. جواهرساز:</strong> نیاز به تمرکز، دقت، ظرافت و صبر بالا دارد. افراد High S در ساخت‌های دقیق و تکراری عملکرد درخشانی دارند.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>16. سفالگر یا هنرمند صنایع دستی:</strong> فضای آرام، قابل کنترل، و خروجی ملموس و زیبای کار. امکان غرق شدن در فرآیند با آرامش کامل وجود دارد.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>17. نجار:</strong> کار ساختارمند، دقیق و تکراری با تعامل محدود. High Sها در اجرای دقیق نقشه‌ها و طراحی‌های مشخص عالی‌اند.
                </p>

            </Page>

            <Page
                testResult={testResult}
            >
                <p className="text-gray-800 leading-7">
                    <strong>18. متخصص گفتاردرمانی:</strong> نیاز به ارتباط صبورانه، پیگیری بلندمدت، برنامه‌ریزی درمانی و حمایت مداوم از کودک یا بیمار.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>19. شنوایی‌سنج:</strong> کار تخصصی دقیق، با محیط آرام و کم‌تنش. High Sها با دقت و توجه بالا، در این حرفه خوش می‌درخشند.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>20. چشم‌پزشک:</strong> ترکیب دقت، کار تخصصی در محیط کنترل‌شده و امکان تعامل انسانی بدون استرس زیاد.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>21. جراح:</strong> اگرچه فشار دارد، اما برای High Sهای با تمرین و تقویت مهارت‌های تصمیم‌گیری سریع، محیط دقیق و مشخص اتاق عمل می‌تواند مناسب باشد.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>22. دامپزشک:</strong> نیاز به صبر، ارتباط عاطفی، دلسوزی، و مراقبت. ایده‌آل برای High Sهایی که علاقه به حیوانات دارند.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>23. داروساز:</strong> کار دقیق، با چارچوب مشخص، بدون نیاز به تعامل پرتنش. مناسب برای High Sهایی که به نظم و جزئیات علاقه دارند.
                </p>
                <p className="text-gray-800 leading-7">
                    <strong>24. مترجم:</strong> فعالیتی تخصصی، تمرکزگرا، و کم‌تنش. محیط معمولاً خلوت و با ثبات است و برای High Sها بسیار ایده‌آل.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="همسر مناسب برای افراد با الگوی High S و نحوه ارتباط مؤثر با او"

            >
                <p className="text-gray-800 leading-7">
                    افراد با الگوی  High S، در روابط عاطفی و زناشویی نیز مانند سایر بخش‌های زندگی، به‌دنبال امنیت، ثبات، آرامش و همراهی پایدار هستند. این افراد معمولاً به‌شدت وفادار، صبور، حمایت‌گر و بخشنده‌اند، اما احساسات خود را خیلی مستقیم ابراز نمی‌کنند و ترجیح می‌دهند به جای گفتار، با رفتارشان محبت کنند.
                    از آن‌سو، شریک زندگی آن‌ها باید این ویژگی‌ها را درک کرده و قدر بداند؛ زیرا ممکن است یک  High S به‌جای ابراز مستقیم ناراحتی، سکوت کند یا به‌جای خواستن چیزی، منتظر توجه شما بماند. این یعنی اگر شریک زندگی‌اش زبان احساسات او را بلد نباشد، احتمال سوءتفاهم و فرسودگی عاطفی بالا می‌رود.

                </p>
            </Page>

            <Page
                testResult={testResult}
                title="ویژگی‌های شخصیتی مناسب برای همسر یک فرد High S"

            >
                <p className="text-gray-800 leading-7">
                    برای اینکه رابطه‌ای عمیق، باثبات و رضایت‌بخش با یک فرد High S شکل بگیرد، شریک عاطفی او باید ویژگی‌هایی داشته باشد که با نیاز روانی، سبک ارتباطی و حساسیت‌های عاطفی این افراد همسو یا تکمیل‌کننده باشد. در ادامه، مهم‌ترین ویژگی‌هایی که یک همسر مناسب برای High S باید داشته باشد آورده شده است:
                </p>

                <p className="text-gray-800 leading-7">
                    <strong>1. آرام، صبور و قابل پیش‌بینی باشد:</strong>
                    <br />
                    High Sها با تنش، تغییرات ناگهانی و رفتارهای غیرمنتظره راحت نیستند. همسری که رفتارش ثبات دارد، با حوصله و قابل پیش‌بینی است، برای آن‌ها یک پناهگاه امن محسوب می‌شود.
                </p>

                <p className="text-gray-800 leading-7">
                    <strong>2. حمایت‌گر و قدردان باشد:</strong>
                    <br />
                    High Sها معمولاً کارهای زیادی برای خانواده و شریک‌شان انجام می‌دهند، اما توقعات زیادی ندارند. با این حال، اگر همسرشان قدردان نباشد یا از آن‌ها تشکر نکند، به مرور احساس دلسردی می‌کنند. یک همسر خوب باید حمایت آن‌ها را ببیند، تأیید کند و با محبت پاسخ دهد.
                </p>

                <p className="text-gray-800 leading-7">
                    <strong>3. توانایی برقراری گفت‌وگوهای آرام را داشته باشد:</strong>
                    <br />
                    چون High Sها احساسات‌شان را مستقیم بیان نمی‌کنند، بهتر است همسر آن‌ها فردی باشد که در گفت‌وگو صبور، غیرتهاجمی و اهل شنیدن باشد. در این صورت فرد High S نیز راحت‌تر احساساتش را باز می‌کند.
                </p>

                <p className="text-gray-800 leading-7">
                    <strong>4. توانمند در تصمیم‌گیری و اقدام باشد:</strong>
                    <br />
                    High Sها گاهی در تصمیم‌گیری تعلل می‌کنند. اگر همسرشان تیپ D یا C تقویت‌شده باشد و بتواند در زمان مناسب قاطعانه تصمیم بگیرد، تکیه‌گاهی مؤثر برای High S خواهد بود و به پیشرفت رابطه کمک می‌کند.
                </p>

                <p className="text-gray-800 leading-7">
                    <strong>5. هیجانی و شتاب‌زده نباشد:</strong>
                    <br />
                    افراد پرهیجان، پرسرعت و کنترل‌گر ممکن است برای High S خسته‌کننده یا حتی تهدیدکننده باشند. همسر مناسب باید بتواند تعادل ایجاد کند، نه فشار بیاورد.
                </p>


            </Page>

            <Page
                testResult={testResult}
            >
                <p className="text-gray-800 leading-7">
                    <strong>6. به آرامش، خانواده‌دوستی و روابط عاطفی عمیق اهمیت بدهد:</strong>
                    <br />
                    High Sها عمیق‌اند، نه سطحی. کسی که به روابط گرم خانوادگی، وفاداری و صمیمیت بلندمدت علاقه دارد، می‌تواند همسر ایده‌آلی برای آن‌ها باشد.
                </p>

                <p className="text-gray-800 leading-7">
                    <strong>7. در برابر سکوت یا کناره‌گیری، پیگیر اما محترمانه باشد:</strong>
                    <br />
                    گاهی High S در برابر ناراحتی یا رنجش، سکوت می‌کند یا کنار می‌کشد. همسر آگاه کسی است که این سکوت را ببینید، بدون سرزنش پیگیر گفت‌وگو شود، و فضای امنی برای ابراز احساسات فراهم کند.
                </p>
            </Page>

            <Page
                testResult={testResult}
                title="نکاتی که همسر یک فرد High S باید بداند"

            >
                <div className="text-gray-800 leading-7 space-y-4">
                    <p>
                        برای داشتن یک رابطه عمیق، امن و پایدار با فردی که دارای الگوی رفتاری High S است، لازم است برخی از ویژگی‌های شخصیتی و نیازهای پنهان او را بشناسید و در رفتار خود نسبت به آن‌ها آگاهانه عمل کنید. در ادامه، مهم‌ترین نکاتی که باید بدانید:
                    </p>

                    <div className="space-y-3">
                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۱. محبت او بیشتر در رفتار است، نه در کلمات</h4>
                            <p>
                                فرد High S ممکن است زیاد "دوستت دارم" نگوید، اما با حضور دائمی، حمایت بی‌قید و شرط، و مسئولیت‌پذیریش، عشق را نشان می‌دهد. دنبال بیان پررنگ احساسات نباشید؛ محبت او در سکوتش جاری است.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۲. اگر ناراحت شد، احتمالاً سکوت می‌کند، نه اعتراض</h4>
                            <p>
                                این افراد اهل دعوا و سرزنش نیستند. اما اگر چیزی آن‌ها را رنجاند، ممکن است کناره‌گیری کنند یا درون‌ریز شوند. اگر متوجه تغییری شدید، صبورانه و بدون قضاوت با او صحبت کنید.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۳. به‌جای فشار آوردن، زمان بدهید</h4>
                            <p>
                                High S برای تصمیم‌گیری یا سازگاری با تغییرات نیاز به زمان دارد. اگر او را تحت فشار قرار دهید، احتمالاً عقب می‌نشیند یا دچار اضطراب می‌شود. در عوض، با حمایت و همراهی، او را وارد مسیر جدید کنید.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۴. برایش محیطی باثبات، محترمانه و بدون تنش بسازید</h4>
                            <p>
                                خانه برای فرد High S باید پناهگاه آرامش باشد، نه میدان نبرد. حتی اگر مشکل دارید، روش گفت‌وگو باید محترمانه، آرام و بدون پرخاشگری باشد.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۵. قدر حمایت‌هایش را بدانید</h4>
                            <p>
                                این افراد اهل نمایش نیستند، اما برای رابطه‌شان حاضرند از خود بگذرند. اگر کار کوچکی برای شما انجام داد، تشکر ساده شما می‌تواند انگیزه‌اش را چند برابر کند.
                            </p>
                        </div>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
            >
                <div className="text-gray-800 leading-7 space-y-4">
                    <div className="space-y-3">
                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۶. در تصمیمات مهم، کمکش کنید اولویت‌ها را ببیند</h4>
                            <p>
                                او ممکن است در برابر انتخاب‌های متعدد گیج شود. در این مواقع، به جای تصمیم‌گیری برایش، کمکش کنید موضوع را ساده‌تر و شفاف‌تر ببیند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۷. به رابطه وفادار است، اما به شرطی که امنیت عاطفی داشته باشد</h4>
                            <p>
                                اگر احساس کند مدام قضاوت می‌شود، یا خواسته‌هایش نادیده گرفته می‌شود، به‌جای اعتراض، آرام‌آرام از نظر احساسی فاصله می‌گیرد. با گفت‌وگو و توجه به نیازهایش، او را در رابطه نگه دارید.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۸. از مقایسه با افراد پرانرژی یا پرهیجان پرهیز کنید</h4>
                            <p>
                                او ممکن است مثل تیپ‌های High I یا High D پرجوش نباشد، اما در عمق، وفادارتر، باثبات‌تر و فداکارتر است.
                            </p>
                        </div>
                    </div>
                </div>
            </Page>

            <Page
                testResult={testResult}
                title="عباراتی که شنیدنش برای یک High S دلگرم‌کننده است"

            >
                <ul className="text-gray-800 leading-7 space-y-2 list-disc list-inside">
                    <li>من به تو تکیه دارم.</li>
                    <li>حضور همیشگی‌ات آرامش‌بخش‌ترین چیزه.</li>
                    <li>دوست دارم بدون عجله با هم حرف بزنیم.</li>
                    <li>ممنونم که همیشه کنارمی، حتی وقتی حرفی نمی‌زنی.</li>
                </ul>
            </Page>

            <Page
                testResult={testResult}
                title="نکاتی که فرد High S باید در زندگی زناشویی رعایت کند"

            >

                <div className="text-gray-800 leading-7 space-y-4">
                    <p>
                        اگرچه افراد با الگوی High S در زندگی مشترک وفادار، آرام، مهربان و قابل اتکا هستند، اما برای حفظ تعادل رابطه و جلوگیری از فرسودگی عاطفی یا سوءتفاهم، نیاز است برخی نکات را آگاهانه تمرین کنند و سبک رفتاری خود را در برخی موارد تقویت نمایند:
                    </p>

                    <div className="space-y-3">
                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۱. احساساتت را واضح‌تر بیان کن</h4>
                            <p>
                                منتظر نباش همسرت با نگاهت بفهمد که چه احساسی داری. تمرین کن که احساسات، نیازها و خواسته‌هایت را با کلمات ساده و مستقیم بیان کنی. سکوت طولانی، فاصله می‌سازد.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۲. تصمیم‌گیری را به دیگران واگذار نکن</h4>
                            <p>
                                در مسائل خانوادگی، اگر همیشه نقش همراه ساکت را بازی کنی، ممکن است مسئولیت‌ها از تعادل خارج شود. تمرین کن در زمان مناسب نظر بدهی، پیشنهاد بدهی و انتخاب کنی، حتی اگر نگران اشتباه باشی.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۳. از تعارف و تحمل بیش از حد دوری کن</h4>
                            <p>
                                تو اهل گذشت و سازش هستی، اما اگر این گذشت‌ها بدون مرز باشد، احساس خستگی و نادیده‌گرفته‌شدن در تو شکل می‌گیرد. حمایت کن، اما نگذار خودت فراموش شوی.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۴. قاطعیت را تمرین کن، نه پرخاش را</h4>
                            <p>
                                قاطع بودن با تند بودن فرق دارد. گاهی لازم است با احترام، اما محکم، بگویی: "من با این موضوع موافق نیستم." یا "الان نیاز دارم تنها باشم." قاطعیت یعنی خودت را هم به رسمیت بشناسی.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۵. گاهی آغازکننده رابطه باش</h4>
                            <p>
                                تو ترجیح می‌دهی ابتدا دیگری ابراز علاقه کند، اما گاهی کافی‌ست خودت پیش‌قدم شوی، در یک جمله محبت‌آمیز، یک تماس ساده یا حتی یک برنامه دونفره. این کار رابطه را زنده نگه می‌دارد.
                            </p>
                        </div>
                    </div>

                </div>
            </Page>

            <Page
                testResult={testResult}

            >
                <div>
                    <div className="space-y-3">
                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۷. مسئولیت خوشحالی خودت را بپذیر</h4>
                            <p>
                                اگر همیشه در خدمت دیگران باشی اما از نیازهای خودت غافل بمانی، دیر یا زود احساس فرسودگی می‌کنی. خودت را دوست داشته باش، خواسته‌هایت را پیگیری کن و برای خودت هم وقت بگذار.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۸. از همسرت بازخورد بخواه</h4>
                            <p>
                                تو معمولاً ساکت از کنار مسائل می‌گذری، اما گاهی از همسرت بپرس: «آیا چیزی هست که دوست داشته باشی من تغییر بدم؟» «در چه چیزی می‌تونم بهتر باشم؟» این تمرین ساده، باعث تقویت گفت‌وگوی عاطفی بین شما می‌شود.
                            </p>
                        </div>
                    </div>

                    <div className="mt-6">
                        <h3 className="font-semibold text-gray-800 mb-3">عباراتی که گفتنش برای فرد High S اثرگذار است (برای تمرین روزانه):</h3>
                        <ul className="space-y-2 list-disc list-inside text-gray-700">
                            <li>«من هم مهمم، نه فقط دیگران.»</li>
                            <li>«نیاز دارم خواسته‌هامو بیان کنم، حتی اگه طرف مقابلم ناراحت بشه.»</li>
                            <li>«پذیرفتن اختلاف نظر، تهدید رابطه نیست، شروع رشدشه.»</li>
                        </ul>
                    </div>
                </div>
            </Page >

            <Page
                testResult={testResult}
                title="ارتباط مؤثر والدین High S با فرزندان"
            >
                <div className="text-gray-800 leading-7 space-y-6">
                    <p>
                        والدین با الگوی High S معمولاً پدر یا مادری مهربان، حمایت‌گر، صبور، شنونده و وفادار هستند. آن‌ها ترجیح می‌دهند فرزندشان در آرامش، امنیت عاطفی و فضای بدون تنش رشد کند. اما در این میان، چالش‌هایی هم وجود دارد که با آگاهی از آن‌ها می‌توان کیفیت رابطه را بهبود بخشید:
                    </p>

                    <div className="space-y-3">
                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۱. محبت خود را کلامی‌تر کنید</h4>
                            <p>
                                فرزند شما نیاز دارد محبت شما را نه فقط در عمل، بلکه در کلام هم بشنود. جملاتی مثل «دوستت دارم»، «بهت افتخار می‌کنم» یا «بودنت برام ارزشمنده» باید بخشی از گفت‌وگوهای روزمره‌تان شود.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۲. مرزهای تربیتی را مشخص و شفاف تعریف کنید</h4>
                            <p>
                                مهربانی نباید به بی‌قاطعیتی تبدیل شود. اگر قانون مشخصی در خانه دارید، آن را با آرامش ولی محکم پیاده کنید. فرزند شما به وضوح نیاز دارد، حتی اگر در لحظه مقاومت کند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۳. از تصمیم‌گیری فرار نکنید</h4>
                            <p>
                                فرزندتان نیاز دارد بداند که شما رهبر خانواده هستید، نه فقط همراهی ساکت. اگر در زمان‌های حساس، تصمیم‌گیری را به تعویق بیندازید، ناخواسته حس ناامنی منتقل می‌شود.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۴. از بیش‌ازحد حمایت‌کردن پرهیز کنید</h4>
                            <p>
                                گاهی لازم است اجازه دهید فرزندتان اشتباه کند و یاد بگیرد. حمایت شما نباید مانع استقلال یا رشد مسئولیت‌پذیری او شود.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۵. وقتی ناراحتید، گفت‌وگو را به تعویق نیندازید</h4>
                            <p>
                                شما ممکن است از ناراحتی فرزندتان رنج ببرید و به‌جای گفت‌وگو، سکوت را انتخاب کنید. اما پرهیز از گفت‌وگو، فاصله عاطفی ایجاد می‌کند. حتی ناراحتی‌ها را با زبان محبت‌آمیز، ولی شفاف بیان کنید.
                            </p>
                        </div>
                    </div>
                </div>
            </Page >

            <Page
                testResult={testResult}
            >
                <div className="text-gray-800 leading-7 space-y-6">
                    <h3 className="font-semibold text-gray-800">اگر پدر یا مادر شما دارای الگوی High S هستند</h3>
                    <p className="mb-4">
                        بدانید که او دوستتان دارد، حتی اگر زیاد این را نگوید. رفتارهایی هستند که می‌توانند به تقویت رابطه‌تان کمک کنند:
                    </p>

                    <div className="space-y-3">
                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۱. از او قدردانی کنید، حتی برای کارهای کوچک</h4>
                            <p>
                                کلمه‌ای مثل «ممنونم که همیشه هستی» یا «از اینکه همیشه حواست به من هست متشکرم» می‌تواند انرژی و انگیزه زیادی به او بدهد.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۲. با لحن تند یا رفتارهای پرهیجان، او را نترسانید</h4>
                            <p>
                                اگر ناگهانی داد بزنید، در را بکوبید یا بی‌احترامی کنید، والد High S ممکن است سکوت کند، ولی از درون آسیب ببیند. آرام صحبت کنید و اگر اشتباهی کردید، عذرخواهی را فراموش نکنید.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۳. احساساتش را جدی بگیرید، حتی اگر خیلی بروز نمی‌دهد</h4>
                            <p>
                                اگر دیدید ناراحت است، کنارش بنشینید و بگویید: «می‌دونم شاید چیزی ناراحتت کرده. دلت می‌خواد در موردش حرف بزنیم؟» این جمله‌ها کمک می‌کنند او احساس امنیت کند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۴. از او زیاد نخواهید که ناگهانی تصمیم بگیرد</h4>
                            <p>
                                اگر درخواست بزرگی دارید، به او زمان بدهید تا فکر کند. عجله، اضطراب او را بیشتر می‌کند.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold text-gray-800 mb-2">۵. با او برنامه‌های مشترک و بدون تنش داشته باشید</h4>
                            <p>
                                مثلاً پیاده‌روی، تماشای فیلم خانوادگی، یا حتی کمک در کارهای خانه. High Sها در فضای بدون تنش، بیشترین نزدیکی عاطفی را با فرزند تجربه می‌کنند.
                            </p>
                        </div>
                    </div>
                </div>
            </Page >
        </>
    )
}

export default HighS
